<template>
  <div style="font-size: 14px; width: 100%">
    <template v-if="!orderStatus">
      <div class="buy-layout buy-order-layout">
        <div class="buy-layout-header">
          <div class="buy-layout-header-inner">
            <div class="buy-layout-header-title">
              <div class="pay-layout-header-title">支付订单</div>
            </div>
          </div>
        </div>

        <div class="buy-layout-body">
          <div class="buy-layout-body-inner">
            <div class="buy-layout-main">
              <div class="buy-layout-main-inner">
                <div class="tea-card">
                  <div class="tea-card__body">
                    <div class="tea-card__title">
                      <div class="tea-justify-grid">
                        <div class="tea-justify-grid__col tea-justify-grid__col--left">
                          <h3 class="tea-h3">待支付订单</h3>
                        </div>
                      </div>
                    </div>
                    <div class="tea-card__content">
                      <el-table :data="orderData.orderItems" border :header-cell-style="{ background: '#f9f9f9' }"
                        style="width: 100%">
                        <el-table-column prop="title" label="产品名称" align="center">
                        </el-table-column>
                        <el-table-column prop="specName" label="规格" align="center" width="180">
                        </el-table-column>
                        <el-table-column prop="price" label="单价" align="center" width="180">
                        </el-table-column>
                        <el-table-column prop="count" label="数量" align="center" width="180">
                        </el-table-column>
                        <el-table-column prop="subtotal" label="小计" align="center" width="180">
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>

                <!-- <div class="tea-card pay-card-coupon" style="margin-top: 20px">
                  <div class="tea-card__body">
                    <div class="tea-card__title">
                      <div class="tea-justify-grid">
                        <div class="tea-justify-grid__col tea-justify-grid__col--left">
                          <h3 class="tea-h3">已选中优惠券</h3>
                        </div>
                      </div>
                    </div>
                    <div class="tea-card__content">
                      <div class="coupon-way">
                        <div class="coupon-info" v-if="!orderData.couponList.length">
                          <div class="option-inner">
                            <div class="option-text">暂无可用优惠券</div>
                          </div>
                        </div>
                        <div class="option" v-for="coupon in orderData.couponList" :key="coupon.id"
                          :class="{ 'option-active': selectedCouponId === coupon.id, 'option-disabled': coupon.goodsId !== orderData.orderItems[0].goodsId }"
                          @click="coupon.goodsId !== orderData.orderItems[0].goodsId ? '' : selectedCouponId = coupon.id ">
                          <div class="option-inner">
                            <div class="option-radio">
                              <el-radio v-model="selectedCouponId" :label="coupon.id" class="pay-icon" :disabled="coupon.goodsId !== orderData.orderItems[0].goodsId">
                                ¥{{ coupon.amount }} 优惠券
                              </el-radio>
                              <span v-if="coupon.goodsId !== orderData.orderItems[0].goodsId"
                                class="option-disabled">该优惠券当前商品不可用</span>
                            </div>
                            <div class="option-goods">
                              <span class="goods-name">适用商品：</span>
                              <span class="goods-list">{{ coupon.goodsInfo.title }}</span>
                            </div>
                            <div class="option-expire-time">
                              <span v-if="coupon.expireTime" class="expire-time">有效期至：{{ new Date(coupon.expireTime) | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
                              <span v-else class="expire-time">长期有效</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                
                <div class="tea-card pay-card-coupon" style="margin-top: 20px">
                  <div class="tea-card__body">
                    <div class="tea-card__title">
                      <div class="tea-justify-grid">
                        <div class="tea-justify-grid__col tea-justify-grid__col--left">
                          <h3 class="tea-h3">已选中优惠券</h3>
                        </div>
                      </div>
                    </div>
                    <div class="tea-card__content">
                      <div class="coupon-way">
                        <div class="coupon-info" v-if="!orderData.couponList.length">
                          <div class="option-inner">
                            <div class="option-text">暂无可用优惠券</div>
                          </div>
                        </div>
                        <div class="option" v-for="coupon in orderData.couponList" :key="coupon.id"
                          :class="{ 'option-active': selectedCouponId === coupon.id, 'option-disabled': coupon.goodsId !== orderData.orderItems[0].goodsId }"
                          @click="coupon.goodsId !== orderData.orderItems[0].goodsId ? '' : selectedCouponId = coupon.id ">
                          <div class="option-inner">
                            <div class="option-radio">
                              <el-radio v-model="selectedCouponId" :label="coupon.id" class="pay-icon" :disabled="coupon.goodsId !== orderData.orderItems[0].goodsId">
                                ¥{{ coupon.amount }} 优惠券
                              </el-radio>
                              <span v-if="coupon.goodsId !== orderData.orderItems[0].goodsId"
                                class="option-disabled">该优惠券当前商品不可用</span>
                            </div>
                            <div class="option-goods">
                              <span class="goods-name">适用商品：</span>
                              <span class="goods-list">{{ coupon.goodsInfo.title }}</span>
                            </div>
                            <div class="option-expire-time">
                              <span v-if="coupon.expireTime" class="expire-time">有效期至：{{ new Date(coupon.expireTime) | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</span>
                              <span v-else class="expire-time">长期有效</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tea-card payway-scroll-anchor" style="margin-top: 20px">
                  <div class="tea-card__body">
                    <div class="tea-card__title">
                      <div class="tea-justify-grid">
                        <div class="tea-justify-grid__col tea-justify-grid__col--left">
                          <h3 class="tea-h3">支付方式</h3>
                        </div>
                      </div>
                    </div>
                    <div class="tea-card__content">
                      <div class="pay-way">
                        <div class="option" @click="paymentMethod = 'wechat'"
                          :class="{ 'option-active': paymentMethod === 'wechat' }">
                          <div class="option-inner">
                            <div class="option-icon">
                              <img src="@/assets/pay/wechat.png" alt="微信支付" class="pay-icon" />
                            </div>
                            <div class="option-text">微信支付</div>
                          </div>
                        </div>
                        <!-- <div class="option" @click="paymentMethod = 'alipay'"
                          :class="{ 'option-active': paymentMethod === 'alipay' }">
                          <div class="option-inner">
                            <div class="option-icon">
                              <img src="@/assets/pay/alipay.png" alt="支付宝支付" class="pay-icon" />
                            </div>
                            <div class="option-text">支付宝支付</div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-order-card">
        <div class="card-container">
          <div class="submit-info">
              <div class="payment-way">
                <div v-show="paymentMethod === 'wechat'" class="payment-way-item payment-online">
                  <img src="@/assets/pay/wechat.png" alt="微信支付" class="buy-icon" />
                  <span class="payment-way-text">微信支付</span>
                </div>
                <div v-show="paymentMethod === 'alipay'" class="payment-way-item payment-online">
                  <img src="@/assets/pay/alipay.png" alt="支付宝支付" class="buy-icon" />
                  <span class="payment-way-text">支付宝支付</span>
                </div>
              </div>
              <div class="coupon-info">
                <span class="label">优惠券</span>
                <span class="price">
                  -¥{{ selectedCouponId ? orderData.couponList.find(coupon => coupon.id === selectedCouponId).amount.toFixed(2) : 0 }}
                  <span class="unit">元</span>
                </span>
              </div>
              <div class="pay-info">
                <span class="label">实付金额</span>
                <span class="price">
                  ¥{{ couponAmount }}
                  <span class="unit">元</span>
                </span>
              </div>
            <el-button class="tea-btn submit-btn" size="large" @click="submitOrder">支付</el-button>
          </div>
        </div>
      </div>

      <el-dialog title="微信扫码支付" :visible.sync="dialogPayVisible" :close-on-click-modal="false" width="600px"
        class="pay-dialog" @close="handlePaymentClose" center>
        <div style="text-align: center; margin-bottom: 15px; display: none;">
          <span style="font-size: 16px">距离二维码过期还剩X秒，过期后请刷新页面重新获取二维码。</span>
        </div>

        <div style="display: flex; justify-content: center;">
          <div>
            <div class="qrcode">
              <img v-if="qrCodeURL" :src="qrCodeURL" alt="微信支付二维码" />
            </div>
            <div class="pw-box-ft">
              <p>请使用微信扫一扫</p>
              <p>扫描二维码支付</p>
            </div>
          </div>
          <div class="p-w-sidebar"></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handlePaymentSuccess" type="danger">
            已完成支付
          </el-button>
          <el-button @click="handlePaymentMethodChange">
            更换支付方式
          </el-button>
        </div>
      </el-dialog>
    </template>
    <el-empty v-else description="订单信息不存在或已支付完成">
      <el-button @click="toOrders" type="primary">返回订单列表</el-button>
    </el-empty>
  </div>
</template>

<script>
import { orderService, orderCouponService } from "@/api/orders";
import { weChatPayService } from "@/api/pays";
import { couponsService } from "@/api/coupons";


export default {
  name: "OrderPay",
  data() {
    return {
      fileWebSite: process.env.VUE_APP_FILE_URL,
      orderId: null,
      orderStatus: null,
      orderData: {
        orderItems: [],
        orderCoupon: null, // 优惠券
        couponList: [], // 可用优惠券列表
        total: 0,
      },
      // 选中的优惠券
      selectedCouponId: null,
      // 支付方式
      paymentMethod: "wechat",
      dialogPayVisible: false,
      qrCodeURL: "",
      payTimer: null,
    };
  },
  computed: {
    // 计算优惠券金额
    couponAmount() {
      const selectedCoupon = this.orderData.couponList.find(
        (coupon) => coupon.id === this.selectedCouponId
      );

      const totalPrice = this.orderData.total;
      if (selectedCoupon) {
        return (totalPrice - selectedCoupon.amount < 0 ? 0 : totalPrice - selectedCoupon.amount).toFixed(2);
      }
      return totalPrice.toFixed(2);
    },
  },
  created() {
    this.getOrder();
  },
  methods: {
    getOrder() {
      orderService.getOrderByOrderNo(this.$route.query.orderNo).then((res) => {
        this.orderId = res.id;
        this.orderStatus = res.status;
        this.orderData.orderItems = res.orderItems.map((item) => {
          return {
            goodsId: item.goodsId,
            title: item.title,
            specName: item.specName,
            price: item.price,
            count: item.count,
            subtotal: item.price * item.count,
          };
        });
        this.orderData.total = res.total;

        this.getCouponList(); // 获取优惠券列表
      });
    },
    getCouponList() {
      // 获取可用的优惠券列表
      // couponsService.getAvailableCoupons().then((res) => {
      //   this.orderData.couponList = res;
      // });
      Promise.all([
        couponsService.getAvailableCoupons(),
        orderCouponService.getOrderCouponsByOrderId(this.orderId)
      ])
      .then(responses => {
        const res1 = responses[0] // 获取第一个请求返回的数据
        const res2 = responses[1] // 获取第二个请求返回的数据

        var couponList = [].concat(res1); // 合并两个优惠券列表
        if (res2) {
          couponList.push(res2.coupon); // 如果第二个请求有数据，则添加到列表中
        }
        this.orderData.couponList = couponList;
      });
    },
    submitOrder() {
      if (this.paymentMethod === "wechat") {
        // weChatPayService
        //   .submitOrder({
        //     outTradeNo: this.$route.query.orderNo,
        //     description: "铂元跨境训练营订单-" + this.$route.query.orderNo,
        //     amount: {
        //       total: this.orderData.total * 100, // 转为分
        //       currency: "CNY",
        //     },
        //   })
        //   .then((res) => {
        //     this.qrCodeURL = res.qrCodeImage;
        //     var outTradeNo = res.outTradeNo;
        //     this.dialogPayVisible = true;
        //     // 检查订单号是否有效
        //     if (outTradeNo === undefined || outTradeNo === null) {
        //       this.$message.error("订单号无效，请重新下单");
        //       return;
        //     }
        //     // 启动轮询检查支付状态
        //     this.payTimer = setInterval(() => {
        //       weChatPayService
        //         .checkOrderStatus(outTradeNo)
        //         .then((status) => {
        //           if (status === "SUCCESS") {
        //             clearInterval(this.payTimer);
        //             this.handlePaymentSuccess();
        //           } else if (status === "CLOSED") {
        //             clearInterval(this.payTimer);
        //             this.$message.error("订单已关闭，请重新下单");
        //           }
        //         })
        //         .catch((error) => {
        //           console.error("检查支付状态失败", error);
        //         });
        //     }, 2000); // 每2秒检查一次
        //   })
        //   .catch((error) => {
        //     console.error("微信支付订单创建失败", error);
        //   });
        // 支付前检查订单数据
        orderService.checkOrderBeforePay({
          orderNo: this.$route.query.orderNo,
          paymentMethod: this.paymentMethod,
          amount: this.couponAmount,
          orderItems: this.orderData.orderItems,
          couponId: this.selectedCouponId,
        }).then((res) => {
          this.qrCodeURL = res.qrCodeImage;
          var outTradeNo = res.outTradeNo;
          this.dialogPayVisible = true;
          // 检查订单号是否有效
          if (outTradeNo === undefined || outTradeNo === null) {
            this.$message.error("订单号无效，请重新下单");
            return;
          }
          // 启动轮询检查支付状态
          this.payTimer = setInterval(() => {
            weChatPayService
              .checkOrderStatus(outTradeNo)
              .then((status) => {
                if (status === "SUCCESS") {
                  clearInterval(this.payTimer);
                  this.handlePaymentSuccess();
                } else if (status === "CLOSED") {
                  clearInterval(this.payTimer);
                  this.$message.error("订单已关闭，请重新下单");
                }
              })
              .catch((error) => {
                console.error("检查支付状态失败", error);
              });
            }, 2000); // 每2秒检查一次
        });
          
      } else if (this.paymentMethod === "alipay") {
        // 处理支付宝支付逻辑
        console.log("支付宝支付逻辑待实现");
      }
    },
    handlePaymentSuccess() {
      this.dialogPayVisible = false;
      // 可以在这里跳转到订单详情页或其他页面
      this.$router.push({ path: "/profile?tab=order" });
    },
    // 处理支付方式切换
    handlePaymentMethodChange() {
      this.dialogPayVisible = false; // 关闭支付对话框
      this.qrCodeURL = ""; // 清除二维码
      if (this.payTimer) {
        clearInterval(this.payTimer); // 清除之前的轮询
      }
    },
    handlePaymentClose() {
      if (this.payTimer) {
        clearInterval(this.payTimer); // 清除之前的轮询
      }
    },
    toOrders() {
      this.$router.push({ path: "/profile?tab=order" });
    },
  },
};
</script>

<style scoped lang="scss">
.buy-layout {
  min-height: calc(100vh - 382px);
}

.buy-order-layout {
  min-width: 1180px;
}

@media only screen and (min-width: 1756px) {
  .buy-layout {
    max-width: 1660px;
  }
}

.buy-layout {
  max-width: 1180px;
  margin: 0 auto;
  padding-bottom: 112px;
  font-size: 14px;
}

.buy-layout-header {
  padding-top: 40px;
}

.buy-layout-header-inner {
  display: flex;
  align-items: baseline;
}

.buy-layout-header-title {
  float: left;
  font-size: 32px;
  font-weight: 700;
}

.buy-layout-header-title {
  float: left;
  font-size: 32px;
  font-weight: 700;
}

.buy-layout-header .buy-layout-header-title {
  font-weight: 400;
}

.buy-layout-header-sub-title {
  float: left;
}

.buy-layout-header-sub-title .buy-divider {
  margin: 0 12px;
  vertical-align: middle;
}

.buy-divider-vertical {
  display: inline-block;
  width: 1px;
  height: 16px;
}

.buy-divider {
  // height: 1px;
  overflow: hidden;
  background: #e2e6ed;
}

.buy-layout-header .buy-layout-header-sub-title .buy-link {
  color: #0052d9;
}

a {
  background-color: transparent;
  text-decoration: none;
  color: #006eff;
  cursor: pointer;
}

.buy-layout-body {
  min-height: inherit;
  position: relative;
}

.buy-layout-body {
  margin-top: 40px;
}

.buy-layout-body .buy-layout-body-inner {
  min-height: auto;
}

.buy-layout-body-inner {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

@media only screen and (min-width: 1756px) {
  .buy-layout .buy-layout-main {
    width: 100%;
  }
}

.buy-layout-main {
  width: 830px;
  display: block;
}

.buy-layout-main {
  width: 829px;
}

.buy-layout-main,
.buy-layout-side {
  vertical-align: top;
  display: table-cell;
}

@media only screen and (min-width: 1756px) {
  .buy-layout .buy-layout-main .buy-layout-main-inner {
    padding: 0;
  }
}

.buy-layout-main-inner {
  padding: 0 20px 0 0;
}

.tea-card {
  font-size: 30px;
  background: none;
  box-shadow: 0 0 0 transparent;
}

.tea-card {
  // background-color: #fff;
  // box-shadow: 0 2px 4px 0 rgba(54, 58, 80, .32);
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.9);
}

.tea-card__body {
  font-size: 12px;
  padding: 0px;
}

.tea-card__title {
  margin-bottom: 12px;
}

.tea-justify-grid {
  display: flex;
  width: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.9);
  box-sizing: border-box;
}

.tea-justify-grid .tea-justify-grid__col--left,
.tea-justify-grid .tea-justify-grid__col:first-child {
  text-align: left;
}

.tea-justify-grid .tea-justify-grid__col {
  flex: auto;
  vertical-align: middle;
  text-align: right;
  font-size: 0;
}

.tea-card__title .tea-h3 {
  font-size: 18px;
  font-weight: 700;
}

.tea-card__title .tea-h3,
.tea-card__title h3 {
  color: #000;
}

.tea-card__title .tea-h3:before {
  position: relative;
  top: -2px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 22px;
  background: #0052d9;
  vertical-align: middle;
  margin: 0 10px 0 0;
}

.submit-order-card {
  background: #fff;
  box-shadow: 0 0 12px rgba(24, 44, 108, 0.15);
  // position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  width: 100%;
  min-width: 1180px;
  height: 88px;
  z-index: 98;
}

.submit-order-card .card-container {
  height: 100%;
  max-width: 1180px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.submit-order-card .card-container .submit-info {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.submit-order-card .card-container .submit-info .coupon-info {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.submit-order-card .card-container .submit-info .coupon-info .label {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.9);
  margin-right: 16px;
}

.submit-order-card .card-container .submit-info .coupon-info .price {
  color: #ff7200;
  margin-left: 4px;
  font-weight: 500;
  font-size: 22px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
}

.submit-order-card .card-container .submit-info .coupon-info .price .unit {
  font-size: 12px;
}

.submit-order-card .card-container .submit-info .pay-info {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.submit-order-card .card-container .submit-info .pay-info .label {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.9);
  margin-right: 16px;
}

.submit-order-card .card-container .submit-info .pay-info .price {
  color: #ff7200;
  margin-left: 4px;
  font-weight: 500;
  font-size: 22px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
}

.submit-order-card .card-container .submit-info .pay-info .price .unit {
  font-size: 12px;
}

.submit-order-card .card-container .submit-info .submit-btn {
  width: 136px;
  height: 40px;
  background-color: #0052d9;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.submit-order-card .card-container .submit-info .payment-way {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  margin-right: 8px;
}

.submit-order-card .card-container .submit-info .payment-way .payment-online {
  display: flex;
  align-items: center;
}

.submit-order-card .card-container .submit-info .payment-way .payment-way-item {
  margin-right: 20px;
}

.submit-order-card .card-container .submit-info .payment-way .buy-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.submit-order-card .card-container .submit-info .coupon-info {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
// .submit-order-card .card-container .submit-info .coupon-info .label {
//   color: rgba(0, 0, 0, 0.9);
//   font-size: 14px;
//   font-weight: 400;
//   border-bottom: 1px dashed rgba(0, 0, 0, 0.9);
//   margin-right: 16px;
// }


.coupon-way {
  // display: flex;
  margin-right: -12px;
}
.coupon-way .option {
  background: #fff;
  border: 1px solid #e2e6ed;
  min-height: 130px;
  width: calc(50% - 12px);
  flex: 1;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  margin-right: 12px;
  margin-bottom: 12px;

  float: left;
}

.coupon-way .option:hover {
  cursor: pointer;
  border: 1px solid #0052d9;
}

.coupon-way .option-active {
  border: 1px solid #0052d9;
}

.coupon-way .option-goods {
  margin-top: 5px;
  font-size: 14px;
  color: #333;
}
.coupon-way .option-goods .goods-name {
  font-weight: 700;
}

.coupon-way .option-goods .goods-list {
  color: #999;
}

.coupon-way .option-expire-time {
  margin-top: 5px;
  font-size: 14px;
  color: #999;
}


.pay-way {
  display: flex;
  margin-right: -12px;
}

.pay-way .option {
  background: #fff;
  border: 1px solid #e2e6ed;
  min-height: 130px;
  // max-width: calc(50% - 12px);
  max-width: 142px;
  flex: 1;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  margin-right: 12px;
  display: flex;
}

.pay-way .option-disabled {
  cursor: not-allowed;
}

.pay-way .option:hover {
  cursor: pointer;
  border: 1px solid #0052d9;
}

.pay-way .option-active {
  border: 1px solid #0052d9;
}

.pay-way .option:after {
  position: absolute;
  content: "";
  width: 24px;
  height: 24px;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRTZFOEVFIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0yNCAwdjI0SDB6Ii8+PHBhdGggc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGQ9Ik0xMiAxN2wzIDMgNi4wMTUtNyIvPjwvZz48L3N2Zz4=);
  background-size: cover;
  right: 0;
  bottom: 0;
}

.pay-way .option-active:after {
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMSAwdjMxSDBMMzEgMHoiIGZpbGw9IiMwMDUyRDkiLz48cGF0aCBkPSJNMTYgMjJsMyAzIDctOCIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz48L3N2Zz4=);
  background-size: cover;
}

.option-text {
  font-size: 16px;
  color: #000;
  text-align: center;
}
</style>

<style>
.pay-dialog .el-dialog__body {
  padding-top: 15px;
  padding-bottom: 40px;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
}

.pay-dialog .el-dialog__footer {
  border: 1px solid #e2e6ed;
  padding: 20px;
}

.qrcode {
  border: 1px solid #e2e6ed;
  margin-bottom: 10px;
}

/* .pw-box-ft {
    height: 60px;
    padding: 8px 0 8px 125px;
    background: #ff7674 url(//storage.360buyimg.com/payment-assets/pc/icon/icon-red.png) 50px 8px no-repeat;
} */

.pw-box-ft {
  height: 60px;
  padding: 8px 0 8px 70px;
  background: #ff7674 url(//storage.360buyimg.com/payment-assets/pc/icon/icon-red.png) 15px 8px no-repeat;
}

.pw-box-ft p {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
  font-weight: 700;
}

/* .p-w-sidebar {
    float: left;
    width: 379px;
    height: 421px;
    padding-left: 50px;
    margin-top: -20px;
    background: url(//storage.360buyimg.com/payment-assets/pc/icon/phone-bg.png) 50px 0 no-repeat;
} */
.p-w-sidebar {
  width: 220px;
  height: 280px;
  background: url("~@/assets/pay/pc/pc_icon_phone-bg.png") 20px 0 no-repeat;
  background-size: 100%;
}

/* .pay-dialog .el-dialog {
  width: 20% !important;
}

@media (max-width: 992px) {
  .pay-dialog .el-dialog {
    width: 40% !important;
  }
}

@media only screen and (max-width: 767px) {
  .pay-dialog .el-dialog {
    width: 60% !important;
  }
} */
</style>
